/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "./Lang"
import BaseCom from "./BaseCom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import './DataTable.css';

export default class DataTable extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: props.data,
            columns: [],
            filterValues: {},
            showCheckboxes: props.showCheckboxes,
            totalCount: props.totalCount,
            lastSort: null,
            asc: false
        };
        var n = 0;
        props.columns.forEach((i) => {
            if (typeof (i) == 'string')
                this.state.columns.push({ key: n, name: i, title: i, asc: false });
            else {
                i.key = n;
                if (i.asc === undefined)
                    i.asc = false;
                this.state.columns.push(i);
            }
            n++;
        });
        this.getFilterByName = this.getFilterByName.bind(this);
        this.processLink = this.processLink.bind(this);
        this.setSort = this.setSort.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.processColumns(this.state.columns);
    }

    componentDidMount() {
        if (this.props.defaultSort) {
            var col = this.state.columns?.find(a => a.name === this.props.defaultSort);
            if (col)
                this.setSort(col, this.props.defaultSortDesc);
        }
        if (this.props.columns) {
            const columns = [];
            let n = 0;
            this.props.columns.forEach((i) => {
                if (typeof (i) == 'string')
                    columns.push({ key: n, name: i, title: i, asc: false });
                else {
                    i.key = n;
                    if (i.asc === undefined)
                        i.asc = false;
                    columns.push(i);
                }
                n++;
            });
            this.processColumns(columns);
            this.setState({ columns: columns });
        }
        if (this.props.sortListAPI)
            this.fetchSortList(this.props.sortListAPI);

        window.addEventListener('resize', this.resize);
    }

    componentDidUpdate(prevProps, prevState) {
        var columns;
        if (prevProps.data !== this.props.data) {
            this.setState({ data: this.props.data });
        }
        if (prevProps.totalCount !== this.props.totalCount) {
            this.setState({ totalCount: this.props.totalCount });
        }
        if (prevProps.loading !== this.props.loading) {
            this.setState({ loading: this.props.loading });
        }
        if (prevProps.filters !== this.props.filters) {
            columns = [...this.state.columns];
            this.processColumns(columns);
            this.setState({ filters: this.props.filters, columns: columns });
        }
        if (prevProps.columns !== this.props.columns) {
            columns = [];
            var n = 0;
            this.props.columns.forEach((i) => {
                if (typeof (i) == 'string')
                    columns.push({ key: n, name: i, title: i, asc: false });
                else {
                    i.key = n;
                    if (i.asc === undefined)
                        i.asc = false;
                    columns.push(i);
                }
                n++;
            });
            this.processColumns(columns);
            this.setState({ columns: columns });
            this.processSortList(this.state.sortList, columns);
        }
        if (prevProps.showCheckboxes !== this.props.showCheckboxes)
            this.setState({ showCheckboxes: this.props.showCheckboxes });
        if (prevProps.sortListAPI !== this.props.sortListAPI) {
            this.fetchSortList(this.props.sortListAPI);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize = () => {
        if (this.props.sticky)
            this.forceUpdate();
    }

    fetchSortList = async (api) => {
        this.setState({ sortList: null });
        try {
            let j = await qreq.getAsync(api);
            if (j.list)
                this.processSortList(j.list);
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    processSortList = (sortList, columns) => {
        if (!sortList)
            return;
        if (!columns)
            columns = [...this.state.columns];
        sortList.forEach(i => {
            var col = columns.find(a => a.name?.toLowerCase() === i.name.toLowerCase());
            if (col) {
                col.sortable = true;
                col.sortName = i.name;
            }
        });
        this.setState({ columns: columns, sortList: sortList });
    }

    processColumns(columns) {
        var f;
        columns.forEach(i => {
            f = this.getFilterByName(i.name);
            if (f)
                i.filter = f;
        });
    }

    processLink(loc, row) {
        var rg = /\/:([^\/]+)/g;
        var matches = rg.exec(loc);
        if (matches === null)
            return loc;
        if (matches.length > 1) {
            if (row[matches[1]] !== undefined && row[matches[1]] !== null)
                loc = loc.replace(matches[0], '/' + row[matches[1]]);
        }
        return loc;
    }

    setSort(col, desc) {
        var columns = [...this.state.columns];

        var asc = this.state.asc;

        if (this.state.lastSort === col.key)
            asc = !asc;
        else
            asc = true;

        if (desc)
            asc = false;

        columns.forEach(i => {
            if (i.key !== col.key) {
                i.sort = false;
                i.asc = false;
            }
            else {
                i.sort = true;
                i.asc = asc;
            }
        });

        this.setState({ columns: columns, asc: asc, lastSort: col.key });
        this.props.onSort(col);
    }

    setFilter(e, col) {
        col.filter.value = e;
        if (this.props.onFilter)
            this.props.onFilter(col);
        this.setState({ filterValues: { ...this.state.filterValues, [col.filter.name]: e } });
    }

    getFilterByName(name) {
        if (this.props.filters)
            return this.props.filters.find(a => a.name === name);
        return null;
    }

    toggleCheckbox(row) {
        row.selected = !row.selected;
        this.setState({ data: this.state.data });
    }

    format(col, data, row) {
        try {
            if (col.valueFunc)
                return col.valueFunc(row);
            if (col.format === 'datetime')
                return Globals.toMDYHMLocalDateString(new Date(Date.parse(data)));
            else if (col.format === 'date')
                return Globals.toMDYLocalDateString(new Date(Date.parse(data)));
            else if (col.format === 'bool')
                return data ? 'Yes' : 'No';
        }
        catch { }
        return data;
    }

    rowClick = (row) => {
        this.props.onRowClick?.(row);
    }

    render() {
        let wrapHeight = window.innerHeight;

        if (this.props.heightDelta)
            wrapHeight -= this.props.heightDelta;

        return (<>

            {this.props.filters && this.props.showFilters ? <div className="p-3">
                <div className="row">
                    {this.state.columns.filter(a => a.filter).map((obj, idx) => <div key={'a' + idx} className="col-md-2">
                        {obj.filter.type === 'select' ? <>
                            <label className="form-label">{obj.filter.title}</label>
                            <select className="form-control" onChange={e => this.setFilter(e.target.value, obj)}>
                                <option value="">Select {obj.filter.title}</option>
                                {obj.filter.options?.map((i, idx2) => <option key={'b' + idx + '-' + idx2} value={i.id} selected={i.id === this.state.filterValues[obj.filter.name]}>{i.name}</option>)}
                            </select></> : <FormInput model={obj.filter} label={obj.filter.title} name="value" type={obj.filter.type} options={obj.filter.options} onChange={e => { this.setFilter(e, obj) }} />}
                    </div>)}
                </div>

            </div> : ''}

            {this.state.totalCount !== undefined ? <div className="ps-3 pe-3 mb-3">There {this.state.totalCount === 1 ? 'is' : 'are'} a total of {this.state.totalCount} {this.state.totalCount === 1 ? 'item' : 'items'}.</div> : ''}
            <div className={'c-datatable-wrap' + (this.props.sticky ? ' c-datatable-wrap-sticky' : '')} style={this.props.heightDelta ? { height: wrapHeight + 'px' } : null}>
                <table className={'table c-datatable table-responsive ' + (this.props.noStriped ? '' : 'table-striped')} style={this.props.height ? { height: this.props.height } : null}>
                    <thead>
                        <tr>
                            {this.state.showCheckboxes ? <th style={{ width: '25px' }}></th> : ''}
                            {this.state.columns.map((obj, idx) => (

                                <th
                                    key={'c' + idx}
                                    style={{ width: obj.width ? obj.width : (obj.icon ? '25px' : 'auto'), position: this.props.sticky ? 'sticky' : null }}
                                    className={(obj.className ? obj.className : '') + (this.props.headClassName ? ' ' + this.props.headClassName : '' + ((this.props.onSort && !obj.noSort) ? ' sortable' : ''))}
                                >
                                    {obj.icon
                                        ? ''
                                        : (this.props.onSort
                                            && (!this.state.sortList || (this.state.sortList && obj.sortable))
                                            && !obj.noSort
                                            ? <div role="button" className="pointer" onClick={e => { e.preventDefault(); this.setSort(obj); }}>
                                                {obj.title} {this.state.lastSort === obj.key
                                                    ? (!this.state.asc ? <FontAwesomeIcon icon={fa.faCaretDown} />
                                                        : <FontAwesomeIcon icon={fa.faCaretUp} />)
                                                    : ''}
                                            </div>
                                            : obj.title)}</th>)

                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.map((row, idx) => (
                            <tr key={'d' + idx} className={this.state.loading ? 'loading' : null}>
                                {this.state.showCheckboxes ? <td className={row.className}><div className="form-check"><input type="checkbox" className="form-check-input" onChange={(e) => { this.toggleCheckbox(row); }} checked={row.selected ? true : false} /></div></td> : ''}
                                {this.state.columns.map((col, idx2) => (
                                    <td key={'e' + idx + '-' + idx2} className={(col.className ?? '') + (col.icon ? ' text-center' : '') + (row.className ? ' ' + row.className : '')} style={col.style} onClick={() => this.rowClick(row)}>
                                        {col.button ? <button type="button" className="btn btn-primary text-nowrap" onClick={() => col.onClick(row)}>{col.icon ? <><FontAwesomeIcon icon={fa['fa' + col.icon]} /> </> : ''}{col.button}</button>
                                            :
                                            col.name ? (<>{col.onClick ? (<a className={'pointer tt-' + col.key} title={col.linkTitle ?? col.tooltip} onClick={(e) => { e.preventDefault(); col.onClick(row, e); }}>{this.format(col, col.name && row[col.name] ? row[col.name] : '', row)}</a>) : (col.link ? (col.linkTarget ? <a href={this.processLink(col.link, row)} title={col.linkTitle ?? col.tooltip} className={'tt-' + col.key} target={col.linkTarget}>{this.format(col, col.name && row[col.name] ? row[col.name] : '', row)}</a> : <Link to={this.processLink(col.link, row)} title={col.linkTitle ?? col.tooltip} className={'tt-' + col.key}>{this.format(col, col.name && row[col.name] ? row[col.name] : '', row)}</Link>) : (<>{this.format(col, col.name && row[col.name] ? row[col.name] : '', row)}</>))}</>) : (col.icon ? (
                                                col.onClick ? (<a className={'pointer tt-' + col.key} title={col.linkTitle ?? col.tooltip} onClick={(e) => { e.preventDefault(); col.onClick(row, e); }}><FontAwesomeIcon icon={fa['fa' + col.icon]} /></a>) : (col.linkTarget ? <a href={this.processLink(col.link, row)} title={col.linkTitle ?? col.tooltip} className={'tt-' + col.key} target={col.linkTarget}><FontAwesomeIcon icon={fa['fa' + col.icon]} /></a> : <Link to={this.processLink(col.link, row)} title={col.linkTitle ?? col.tooltip} className={'tt-' + col.key}><FontAwesomeIcon icon={fa['fa' + col.icon]} /></Link>)
                                            ) : '')}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>)
    }
}